module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("POUR SEBASTIAN FOX BLACK,"), _c('br'), _vm._v("À PROPOS DE QUI PERSONNE N’A GRAVÉ"), _c('br'), _vm._v("DE MESSAGES MENAÇANTS DANS LA GLACE"), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/com.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c9b7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 66
// module chunks = 0